/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PasswordRestoreInputDto model module.
 * @module model/PasswordRestoreInputDto
 * @version v0
 */
class PasswordRestoreInputDto {
    /**
     * Constructs a new <code>PasswordRestoreInputDto</code>.
     * Password restore body.
     * @alias module:model/PasswordRestoreInputDto
     * @param newPassword {String} 
     * @param token {String} 
     */
    constructor(newPassword, token) { 
        
        PasswordRestoreInputDto.initialize(this, newPassword, token);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, newPassword, token) { 
        obj['newPassword'] = newPassword;
        obj['token'] = token;
    }

    /**
     * Constructs a <code>PasswordRestoreInputDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PasswordRestoreInputDto} obj Optional instance to populate.
     * @return {module:model/PasswordRestoreInputDto} The populated <code>PasswordRestoreInputDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PasswordRestoreInputDto();

            if (data.hasOwnProperty('newPassword')) {
                obj['newPassword'] = ApiClient.convertToType(data['newPassword'], 'String');
            }
            if (data.hasOwnProperty('token')) {
                obj['token'] = ApiClient.convertToType(data['token'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PasswordRestoreInputDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PasswordRestoreInputDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PasswordRestoreInputDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['newPassword'] && !(typeof data['newPassword'] === 'string' || data['newPassword'] instanceof String)) {
            throw new Error("Expected the field `newPassword` to be a primitive type in the JSON string but got " + data['newPassword']);
        }
        // ensure the json data is a string
        if (data['token'] && !(typeof data['token'] === 'string' || data['token'] instanceof String)) {
            throw new Error("Expected the field `token` to be a primitive type in the JSON string but got " + data['token']);
        }

        return true;
    }


}

PasswordRestoreInputDto.RequiredProperties = ["newPassword", "token"];

/**
 * @member {String} newPassword
 */
PasswordRestoreInputDto.prototype['newPassword'] = undefined;

/**
 * @member {String} token
 */
PasswordRestoreInputDto.prototype['token'] = undefined;






export default PasswordRestoreInputDto;

